import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { isModuleBySlug } from "../../../../../../utils/storage"
import { IMPACT_ANALYSIS } from "../../../../../../utils/constants"
import { loadTexts } from "../../../../../../utils/i18n"

export function CustomizedAxisTick(props) {
  const intlDimensionChart = loadTexts("reports_general_view").reportAmbassador
    .engagementMeasurement.widgetResultByDimensionEngagement
    .resultByDimensionChart

  const { x, y, index } = props.element
  const text = props.data[index] && props.data[index].name
  const impact = props.data[index] && props.data[index].impact
  const isImpactAnalysis = isModuleBySlug(IMPACT_ANALYSIS)
  return (
    <g transform={`translate(${x},${y})`}>
      <foreignObject x={-65} y={-5} dy={16} width="130" height="90">
        <div style={{ textAlign: "center" }}>
          <span
            style={{
              color: "#4F4F4F",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              webkitBoxOrient: "vertical",
              webkitLineClamp: "3",
              fontSize: "12px",
              lineHeight: 1.5,
            }}>
            {text}
          </span>
          {text !== "Resultado total" && isImpactAnalysis && !props.hideImpact && (
            <div>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#979797",
                }}>
                {intlDimensionChart.impact}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#4189D9",
                }}>
                {impact > 0 ? impact : "-"}
              </span>
            </div>
          )}
        </div>
      </foreignObject>
    </g>
  )
}

CustomizedAxisTick.propTypes = {
  element: PropTypes.object,
  data: PropTypes.array,
  hideImpact: PropTypes.bool,
}

export default CustomizedAxisTick
